let current;
/** Called ONCE per app, at module init. See the note above for who. */
export function registerDefaultSectionRegistry(registry) {
    current = registry;
}
/** The registry `PageRenderer` falls back to. Resolved at RENDER time — that lateness is the point. */
export function getDefaultSectionRegistry() {
    if (!current) {
        throw new Error('No section registry registered. An app must import `@aquilixshop/ui-react/eager-registry` ' +
            '(storefront) or register the lazy registry (builder) before it renders a page. ' +
            'See renderer/default-section-registry.ts.');
    }
    return current;
}
//# sourceMappingURL=default-section-registry.js.map